module.exports = __webpack_public_path__ + "static/media/UnitedSansReg-Heavy.dde107d6.woff2";